import { Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser, safeRequestParam } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import * as Survey from "survey-react";
import "survey-react/survey.css";
import CustomerPermision from './Summary/CustomerPermision';
import { useHistory } from 'react-router';
import logger from 'src/utils/logger';

const useStyles = makeStyles(() => ({
  root: {},
  contentAnket: {
    minHeight: 430,
  },
}));
function Anket({ className, FisNo, readonly, tasks}) {
  const classes = useStyles();
  const [anketData, setAnketData] = useState({});
  const [anketBitti, setAnketBitti] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mesaj, setMesaj] = useState('Anket Başarıyla Tamamlandı.');
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  let customer = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

  if (!readonly && (!customer || customer.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      customer = loadBaslandiJob();
    }
  }


  let history = useHistory();

  const handleEditClose = () => {
    setOpenEdit(false);
  };
  useEffect(() => {
    const abortController = new AbortController();
    
    if (readonly) {
      setAnketBitti(true);
      setMesaj('Sadece başlandı durumundaki fişler için anket yapılabilir!..');
      return;
    }



    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return;
    }

    let job = jobs[0];

    if (job.FARKLI_SMS === true || job.FARKLI_SMS === 1) {
      handleAnketBitti('Farklı müşteri numarası seçildigi için anket istenmemektedir!...');
      return;
    }

    if (job.FARKLI_SMS === false || job.FARKLI_SMS === 0) {
      if (job.AramaIzin === 0 || job.AramaIzin === false) {
        setOpenEdit(true);
        // return;
      }
    }

    if (parseInt(job.SMS_DOGRULAMA) === 0) { // GetSmsSendCheck en az bir sefer çağırılmalı.
      history.push(`/WorkOrder/${FisNo}/Dogrulama`);
      return;
    }
    GetArtemisAnket(0, abortController);
    
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line
  }, []);

  const GetArtemisAnket = (anketId, abortController) => {
    let jobs = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

    if (!readonly && (!jobs || jobs.length === 0)) {
      const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
      if (current) {
        saveBaslandiJob(current);
        jobs = loadBaslandiJob();
      }
    }


    if (Array.isArray(jobs) && jobs.length > 0) {
      let job = jobs[0];
      setLoading(true);
      axios.get(`GetArtemisAnketV2/${job.BasvuruNo}/${job.BIRIM_KODU}/${job.DURUM_KODU}/${safeRequestParam(job.KUL_MODEL_KODU) || 'A'}/${safeRequestParam(job.ALINAN_SMS_KOD) || 'A'}/${anketId}`, {
        signal: abortController?.signal
      })
        .then(response => {
          if (job.FARKLI_SMS === true) {
            if (response.data.length > 0) {
              if (response.data.elements !== undefined) {
                if (response.data.elements[0]?.Sms === 0 || response.data.elements[0]?.Sms === undefined) {
                  handleAnketBitti('Farklı müşteri numarası seçildigi için anket istenmemektedir!...');
                  return;
                }
              }
            }
          }

          response.data.length === 0 ? handleAnketBitti('Anket Daha Önce Tamamlandı.') : setAnketData(response.data);

          setLoading(false);
        }).catch(error => {
          if (error.name === 'CanceledError' || error.name === 'AbortError') return;
          setLoading(false);
          logger.error("Hata detayı:", error.message);
        })
    }
  }

  const handleAnketBitti = (msg) => {
    setAnketBitti(true);
    setMesaj(msg);
  }
  const handleClose = () => {
    setOpen(false);
  };

  const onComplete = (survey) => {
    setLoading(true);
    let cevaplar = {};
    let anketId = Object.keys(survey.data)[0]?.split('-')[0];
    Object.keys(survey.data).forEach(k => {
      cevaplar = {
        ...cevaplar,
        [k.replace(anketId + '-', '')]: survey.data[k]
      }
    });
    const user = getUser();
    const data = {
      FisNo: FisNo,
      TeknisyenKodu: user.TechnicianId,
      AnketId: anketId,
      Cevaplar: cevaplar,
      Pilot: 1,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisAnket', { jsonString: JSON.stringify(data) }, config)
      .then((response) => {
        const data = response.data;
        if (data.ErrorCode && parseInt(data.ErrorCode) === 0) {
          const newAnketId = parseInt(data.ErrorDescription)
          if (newAnketId === 0) { // Anket bitti.
            handleAnketBitti('Anket Başarıyla Tamamlandı.');
            setLoading(false);
          } else if (newAnketId === -1) { // Sms anketi.
            setLoading(false);
            GetArtemisAnket(0);
          } else {      // Anket devam ediyor...
            setLoading(false);
            GetArtemisAnket(newAnketId);
          }
        } else {
          handleAnketBitti('Bir hata oluştu!.. Hata Kodu: ' + data.ErrorCode + ' Hata Açıklama: ' + data.ErrorDescription);
          setLoading(false);
        }
      }).catch((error) => {
        handleAnketBitti('Bir hata oluştu!.. Hata: ' + error.message);
        setLoading(false);
      });
  };

  var defaultThemeColors = Survey
    .StylesManager
    .ThemeColors["default"];
  defaultThemeColors["$main-color"] = "#FF9800";
  defaultThemeColors["$main-hover-color"] = "#FF9800";
  defaultThemeColors["$text-color"] = "#424242";

  Survey
    .StylesManager
    .applyTheme();

  var model = new Survey.Model(anketData);
  model.locale = 'tr';

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={"Anket İşlemleri"} />
      <Divider />
      <CardContent className={classes.contentAnket}>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {''}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
        {loading ? <CircularProgress
          status="loading"
          style={{ marginLeft: '50%' }}
        />
          :
          (anketBitti ? mesaj
            :
            <Survey.Survey json={anketData} onComplete={onComplete} />
          )
        }
      </CardContent>
      <CustomerPermision
        customer={customer === undefined ? loadBaslandiJob()?.[0] : customer?.[0]}
        onClose={handleEditClose}
        open={openEdit}
      />
    </Card>
  );
}

Anket.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
  })
)(Anket);
